<div fxLayout="row" fxLayoutAlign="start start" fxLayout.lt-md="column">
    <mat-list fxLayoutGap="200px" fxFlex.lt-md="100" *ngIf="recepcion">
        <mat-list-item>
            <h3 matLine>Cliente</h3>
            <p matLine>
                <span class="text-bold"
                    >{{ recepcion.representante.cliente.nombre }}
                </span>
                <br />
                {{ recepcion.representante.cliente.rut }}
            </p>
        </mat-list-item>
        <mat-list-item>
            <h3 matLine>Representante</h3>
            <p matLine>
                <span class="text-bold"
                    >{{ recepcion.representante.nombre }}
                </span>
            </p>
        </mat-list-item>
        <mat-list-item>
            <h3 matLine>Fecha</h3>
            <p matLine>
                <span class="text-bold"
                    >{{ recepcion.fecha | date: "dd-MM-YYYY" }}
                </span>
            </p>
        </mat-list-item>
        <mat-list-item>
            <h3 matLine>ROG-GES</h3>
            <button
                *ngIf="recepcion"
                mat-icon-button
                type="button"
                color="accent"
                (click)="modificarRocGes(recepcion.numeroGes)"
            >
                <mat-icon>edit</mat-icon>
            </button>
            <p matLine>
                <span class="text-bold">{{ recepcion.numeroGes }} </span>
            </p>
        </mat-list-item>
    </mat-list>
</div>

<button *ngIf="!recepcion" mat-button color="accent" (click)="asociarRocGes()">
    ASOCIAR ROC-GES
</button>

<button *ngIf="!recepcion" mat-button color="accent" (click)="asociarInforme()">
    ASOCIAR INFORME
</button>
